import {
  avatarSizesPx,
  type AvatarSize,
} from '@synoptic/ui-kit/avatar/avatar.css.js';
import { getUserS3Url } from './get-user-s3-url';

export const getUserAvatarSrc = (
  userId: string,
  s3Key: string | undefined,
  size: AvatarSize,
) =>
  getUserS3Url(userId, s3Key, {
    w: avatarSizesPx[size],
    h: avatarSizesPx[size],
  })?.toString();
